export const APPLY_CARD = {
  PRODUCT_CATEGORIES: 'Product Categories',
  TARGET_MARKET: 'Target Market',
  APPLY: 'Apply Now',
};
